import Moment from 'moment';
import Api from '@/api';

import State from './state';

const getAvailabilities = async (context, companyId) => {
  if (!companyId) {
    throw new Error('`Company Id is required to retrieve Inspector Availabilities');
  }

  context.commit('setLoading', true);
  context.commit('setError', null);

  if (context.state.filters && context.state.filters.company !== companyId) {
    context.commit('setCompanyFilter', companyId);
    context.commit('setRecords', {});
  }

  try {
    const response = await Api.appointmentService.getAvailabilitiesV2(companyId);
    context.commit('setRecords', response.data.body.availabilities);
    context.commit(
      'setInspectors',
      response.data.body.inspectors
        .sort((a, b) => {
          const textA = a.familyName.toUpperCase();
          const textB = b.familyName.toUpperCase();
          if (textA < textB) return -1;
          if (textA > textB) return 1;
          return 0;
        }),
    );
  } catch (err) {
    context.commit('setError', err.message);
  }

  context.commit('setLoading', false);
};

const resetState = context => {
  context.commit('resetState');
};

const selectFirstAvailability = async ({ commit, getters }) => {
  await commit('setDateFilter', getters.filteredDates[0]);
  commit('setTimeFilter', getters.filteredTimeslots[0]);
};

const selectFirstAvailabilityForDate = ({ commit, getters }) => {
  commit('setTimeFilter', (getters.filteredTimeslots.length > 0)
    ? getters.filteredTimeslots[0]
    : State.filters.time);
};

const setDateFilter = (context, date) => {
  if (!date) {
    context.commit('setDateFilter', State.filters.date);
    return;
  }
  const regex = /^\d{4}-\d{2}-\d{2}$/; // NOSONAR
  if (!regex.test(date)) {
    return;
  }
  const currentMonth = Moment(context.state.filters.date);
  const updateMonth = Moment(date);

  context.commit('setDateFilter', date);
  if (!currentMonth.isSame(updateMonth, 'month')) {
    context.commit('setMonthFilter', updateMonth.format('YYYY-MM'));
  }
};

const setInspectorFilter = (context, inspectorId) => {
  if (!inspectorId) {
    context.commit('setInspectorFilter', State.filters.inspector);
    return;
  }
  if (typeof inspectorId !== 'number') {
    return;
  }
  context.commit('setInspectorFilter', inspectorId);
};

const setMonthFilter = (context, month) => {
  if (!month) {
    context.commit('setMonthFilter', State.filters.month);
    return;
  }
  const regex = /^\d{4}-\d{2}$/; // NOSONAR
  if (!regex.test(month)) {
    return;
  }
  context.commit('setMonthFilter', month);
};

const setTimeFilter = (context, time) => {
  if (!time) {
    context.commit('setTimeFilter', State.filters.time);
    return;
  }
  const regex = /^\d{2}:\d{2}$/; // NOSONAR
  if (!regex.test(time)) {
    return;
  }
  context.commit('setTimeFilter', time);
};

export default {
  getAvailabilities,
  resetState,
  selectFirstAvailability,
  selectFirstAvailabilityForDate,
  setDateFilter,
  setInspectorFilter,
  setMonthFilter,
  setTimeFilter,
};
